import { Injectable } from '@angular/core';
import { environment } from '@benefitsui/environments/environment';
import { GoogleAnalyticsService } from '../analytics/google-analytics.service';
import { Oauth2Client, UserClient } from '@benefitsui/app/api/benefits-clients';
const LOGIN_FLAG = 'BENEFITS_LOGIN_FLAG';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private gaService: GoogleAnalyticsService,
    private oauth2Client: Oauth2Client,
    private userClient: UserClient
  ) {
    this.trackLogin();
  }

  private trackLogin() {
    if (document.referrer.startsWith(environment.loginOrigin) && !sessionStorage.getItem(LOGIN_FLAG)) {
      this.gaService.trackEvent({
        category: 'UserAuthentication',
        action: 'Login'
      });
    }
    sessionStorage.setItem(LOGIN_FLAG, 'true');
  }

  redirectToLogin(state?: string): void {
    if (state) {
      const encodedState = encodeURIComponent(state);
      window.location.href = environment.loginUrl + `&state=${encodedState}`;
    } else {
      window.location.href = environment.loginUrl;
    }
  }

  redirectToDemoLogin(): void {
    window.location.href = environment.loginUrl;
  }

  createState(returnTo?: string): string {
    const state: { [key: string]: string } = {};
    if (returnTo) {
      state.returnTo = returnTo;
    }
    
    return btoa(JSON.stringify(state));
  }

  readState(state?: string): { returnTo?: string } {
    if (!state) {
      return {};
    }

    return JSON.parse(atob(state));
  }

  logout() {    
    sessionStorage.removeItem(LOGIN_FLAG);
    sessionStorage.clear();
    localStorage.clear();
    const isIcap = environment.icapEnabled ?? false;
    const envName = environment.environmentName;
    if(isIcap){
      window.location.href = `${environment.appBaseUrl}/v1/oauth2/logout?clientId=${environment.redirectUrl}`;
    }
    else if(envName.indexOf('demo') !== -1)
    {
      window.location.href = `${environment.appBaseUrl}/v1/oauth2/logout?clientId=${environment.loginUrl}`;
    }
    else{
      window.location.href = `${environment.appBaseUrl}/v1/oauth2/logout?clientId=${environment.clientId}`;
    }         
  }
}    
